<template>
    <div class="error-container">
      <h2>Error 403 - Acceso no autorizado</h2>
      <p>Gogo sabe que esa URL es correcta, pero lo de darte acceso carece de importancia.</p>
      <img src="@/assets/gogonator.jpg" alt="Haha no hiciste login pndj" class="error-image" />
    </div>
    <div>
      <AdSense />
    </div>
  </template>
  
  <script>
  import AdSense from './AdSense.vue';
  export default {
    name: "AppForbidden",
    components: {
      AdSense
    }
  };
  </script>
  
  <style scoped>
  .error-container {
    text-align: center;
  }
  .error-image {
    width: 100%;
    max-width: 400px;
    margin-top: 1em;
  }
  </style>
  